$.fn.TI500 = function() {
  let self = this

  self.find('[data-id]').each(function() {
    $(this).attr('id', $(this).attr('data-id'))
  })

  self.find('.card-tech-icon').click(function(e) {
    if ($(e.target).closest('.card-tech-icon__cta, .post-share').length > 0) {
      return;
    }

    $(this).find('.card-tech-icon__cta').click()
  })


  var hash = window.location.hash;
  if (hash) {
    var $target = $(hash);
    if ($target.length) {
      $target.find('.card-tech-icon__cta').click()
      $('html, body').animate({
        scrollTop: $target.offset().top - $('.header').outerHeight() - 30
      }, 1000); // adjust speed as needed
    }
  }


  return function() {
    return self
  }()
}
